/**
 * Returns appropriate placeholder text based on the number of results
 */
export const getPlaceholder = (
  resultsCount: number,
  defaultPlaceholder: string
): string => {
  return resultsCount === 0 ? defaultPlaceholder : "";
};

/**
 * Extracts nested data from an object based on a dot-notation path
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getNestedData = (data: any, path: string): any => {
  if (!data || !path) return [];

  let result = data;
  const paths = path.split(".");

  for (const segment of paths) {
    if (result && result[segment] !== undefined) {
      result = result[segment];
    } else {
      return [];
    }
  }

  return result || [];
};
